import { Provider } from 'mobx-react'
import { Suspense, useEffect, useState } from 'react'
import { RouterProvider } from 'react-router'

import 'antd/dist/reset.css'
import './index.css'

import store from './stores'

import { GlobalStyles } from './components/GlobalStyle'
import Maintenance from './pages/Maintenance'
import { firestore } from './utils/firebase'
import { ConfigProvider, theme } from 'antd'
import { router } from './router'
import Loading from './components/Loading'

import '@fontsource/bai-jamjuree/400.css'
import '@fontsource/bai-jamjuree/500.css'
import '@fontsource/bai-jamjuree/600.css'
import '@fontsource/bai-jamjuree/700.css'
import '@fontsource/ibm-plex-sans-thai/500.css'
import '@fontsource/ibm-plex-sans-thai/600.css'
import '@fontsource/ibm-plex-sans-thai/700.css'
import '@fontsource/ibm-plex-mono/500.css'
import '@fontsource/ibm-plex-mono/600.css'
import '@fontsource/ibm-plex-mono/700.css'
import styled from '@emotion/styled'

import earthAvif from './assets/images/background/earth.avif'
import earthWebp from './assets/images/background/earth.webp'
import earth from './assets/images/background/earth.png'
import { observer } from 'mobx-react-lite'

const BackgroundContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: end;
  pointer-events: none;
  // background-color: #190200;
  background: linear-gradient(180deg, rgba(0,0,0,1) 0%, rgba(0,0,0,1) 50%, rgba(25,2,0,1) 100%);
  background-size: contain;

  img {
    width: 100%;
    object-fit: contain;
    max-width: 90vw;
    max-height: 50vh;
    margin: 0 auto;
  }
`

const App: React.FC = () => {
  const [maintenance, _setMaintainance] = useState(false)

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          fontFamily: `'Bai Jamjuree',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,'Noto Sans',sans-serif,'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji'`,
          colorPrimary: '#FF691D',
          colorInfoHover: '#FF691D',
        },
        components: {
          Checkbox: {
            colorBorder: 'white',
          },
          Radio: {
            colorBorder: 'white',
          },
        },
      }}
    >
      <Provider store={store}>
        {import.meta.env.VITE_APP_TARGET === 'staging' && (
          <span className="fixed z-[9999] top-0 left-0 p-4 text-[red] text-xl pointer-events-none">
            ใช้เพื่อการทดสอบภายในเท่านั้น ห้ามเผยแพร่
          </span>
        )}
        <GlobalStyles />
        <BackgroundContainer>
          {/* <picture>
            <source type="image/avif" srcSet={earthAvif} />
            <source type="image/webp" srcSet={earthWebp} />
            <img src={earth} alt="" />
          </picture> */}
        </BackgroundContainer>
        <Suspense fallback={<Loading />}>
          {maintenance ? <Maintenance /> : <RouterProvider router={router} />}
        </Suspense>
      </Provider>
    </ConfigProvider>
  )
}

export default observer(App)
